import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import mail from "../../Assets/Projects/mail.jpg";
import emotion from "../../Assets/Projects/emotion.png";
import tinder from "../../Assets/Projects/tinder.jpg";
import utunes from "../../Assets/Projects/utunes.jpg";
import utify from "../../Assets/Projects/utify.jpg";
import ai from "../../Assets/Projects/AI.jpg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={utunes}
              isBlog={false}
              title="U-Tunes"
              description="Personal Chat Room or Workspace to listen Youtube music and hangout with friends build with React.js, Next.js Material-UI, and Firebase. Have features which allows user for realtime messaging, with simultaneously ads Free music with youtube support as well as supports reactions on messages."
              ghLink="https://github.com/anonboy96/MusicChat"
              demoLink="http://utunes.netlify.app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ai}
              isBlog={false}
              title="AI Presentation"
              description="Created a Python-based AI presentation tool utilizing hand detection for seamless slide transitions and interactive marking capabilities. Designed to enhance presentation engagement with gesture-driven interactions."
              ghLink="https://github.com/anonboy96/AI-Presentation"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={tinder}
              isBlog={false}
              title="Tinder - For Collage"
              description="Created a Java-driven college dating app with swipe-based matching, profile management, and chat functionality. Utilized Java for backend logic and Android SDK for a user-friendly mobile interface."
              demoLink="https://btstore.netlify.app/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={mail}
              isBlog={false}
              title="Anonymous Mail Service"
              description="Designed and implemented a secure anonymous email system leveraging PHP and Node.js, demonstrating expertise in backend development and email protocols."
              ghLink="https://github.com/anonboy96/mailer"
              demoLink="https://replit.com/@HytechHunter/mailer?v=1"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={utify}
              isBlog={false}
              title="Utify - Music Player"
              description="Created an ad-free, high-performance music player in Java, featuring fast download capabilities, playlist customization, and seamless audio playback. Utilized JLayer for MP3 decoding and Swing for an interactive UI."
              ghLink="https://github.com/anonboy096/Utify"
              demoLink="https://utify-music.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Fake instagram Account Detection"
              description="Trained a CNN classifier using 'FER-2013 dataset' with Keras and tensorflow backened. The classifier sucessfully predicted the various types of emotions of human. And the highest accuracy obtained with the model was 60.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
  
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
